/**
 * RESPONSIBILITY: draw a band that is a grid of photographs, each opening full size.
 *
 * A grid and not a carousel: every photograph at once, findable and printable. The grid
 * and caption are the event gallery's own classes.
 */
import { idOf } from '@framework/core';
import { Enlarge } from '../Enlarge';
import { BandFrame } from './BandFrame';
import type { BandDef, BandProps } from './kind';

const shown = (b: BandProps['b']) => (b.pictures ?? []).filter((p) => p.image?.path);

function Draw({ b, tinted }: BandProps) {
  return (
    <BandFrame tinted={tinted} heading={b.heading}>
      <ul className="ev-gallery ministry-gallery">
        {shown(b).map((p) => (
          <li key={idOf(p)}>
            <Enlarge value={p.image} className="ministry-shot" />
            {p.caption ? <span className="ev-caption">{p.caption}</span> : null}
          </li>
        ))}
      </ul>
    </BandFrame>
  );
}

export const gallery: BandDef = { has: (b) => shown(b).length > 0, Draw };
